import planningTranslationsHelper from "../../../../languages/planning-translations.helper";
import {
  CandidatureAddErrorType,
  CandidatureAddPlanEntryCandidateCollisionError,
  CandidatureAddOrderInProgressError,
  CandidatureAddOrderNotExistsError,
  CandidatureAddTaxiDriverAssociationNotExistsError,
  CandidatureAddTaxiDriverContractNotValidError,
  CandidatureAddTaxiRailyContractNotExistsError,
} from "./candidature-add-error";

const createPlanEntryCandidateCollisionError =
  (): CandidatureAddPlanEntryCandidateCollisionError => {
    const translations =
      planningTranslationsHelper.getOrderTranslations().driverPlanListing
        .staging;

    return {
      message: translations.planEntryCandidateCollisionErrorLabel,
      params: {},
      type: CandidatureAddErrorType.PLAN_ENTRY_CANDIDATE_COLLISION,
    };
  };

const createTaxiDriverAssociationNotExistsError =
  (): CandidatureAddTaxiDriverAssociationNotExistsError => {
    const translations =
      planningTranslationsHelper.getOrderTranslations().driverPlanListing
        .staging;

    return {
      message: translations.taxiDriverAssociationNotExistsErrorLabel,
      params: {},
      type: CandidatureAddErrorType.TAXI_DRIVER_ASSOCIATION_NOT_EXISTS,
    };
  };

const createOrderNotExistsError = (): CandidatureAddOrderNotExistsError => {
  const translations =
    planningTranslationsHelper.getOrderTranslations().driverPlanListing.staging;

  return {
    message: translations.orderNotExistsErrorLabel,
    params: {},
    type: CandidatureAddErrorType.ORDER_NOT_EXISTS,
  };
};

const createOrderInProgressError = (): CandidatureAddOrderInProgressError => {
  const translations =
    planningTranslationsHelper.getOrderTranslations().driverPlanListing.staging;

  return {
    message: translations.orderInProgressErrorLabel,
    params: {},
    type: CandidatureAddErrorType.ORDER_IN_PROGRESS,
  };
};

const createTaxiDriverContractNotValidError =
  (): CandidatureAddTaxiDriverContractNotValidError => {
    const translations =
      planningTranslationsHelper.getOrderTranslations().driverPlanListing
        .staging;

    return {
      message: translations.taxiDriverContractNotValidErrorLabel,
      params: {},
      type: CandidatureAddErrorType.TAXI_DRIVER_CONTRACT_NOT_VALID,
    };
  };

const createTaxiRailyContractNotValidError =
  (): CandidatureAddTaxiRailyContractNotExistsError => {
    const translations =
      planningTranslationsHelper.getOrderTranslations().driverPlanListing
        .staging;

    return {
      message: translations.taxiRailyContractNotValidErrorLabel,
      params: {},
      type: CandidatureAddErrorType.TAXI_RAILY_CONTRACT_NOT_VALID,
    };
  };

const candidatureAddErrorFactory = {
  createPlanEntryCandidateCollisionError,
  createTaxiDriverAssociationNotExistsError,
  createOrderNotExistsError,
  createOrderInProgressError,
  createTaxiDriverContractNotValidError,
  createTaxiRailyContractNotValidError,
};

export default candidatureAddErrorFactory;
